const makatData = [
  {
    "makat": "441101180",
    "name": "102 מסדר חולים **",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "441101538",
    "name": "135 רשום טיפולים מרפאתיים **",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960300262",
    "name": "אגד 3 אינץ'",
    "sources": [
      "ארגז חופל"
    ]
  },
  {
    "makat": "960300157",
    "name": "אגד אלסטי 4 אינץ'",
    "sources": [
      "ארגז חופל"
    ]
  },
  {
    "makat": "960300009",
    "name": "אגד קובן",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "960300963",
    "name": "אגד, אלסטי; 4 אינצ'",
    "sources": [
      "חובש",
      "חופל"
    ]
  },
  {
    "makat": "960001621",
    "name": "אדרנלין",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962000967",
    "name": "איירוויי 3",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תיק ארן"
    ]
  },
  {
    "makat": "962000916",
    "name": "איירוויי 4",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962053718",
    "name": "אלקטר קיצוב, דפיברלטר; LP15/LP12",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962053009",
    "name": "אלקטרודה לבדיקות מאמץ",
    "sources": [
      "אטנה",
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962053050",
    "name": "אלקטרודה, ח\"פ, לא.ק.ג ומאמץ",
    "sources": [
      "אטנה",
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "967012432",
    "name": "אמבו (Ambu)",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "960005201",
    "name": "אמפ סולומדרול 500 מ\"ג",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960004043",
    "name": "אמפ פלג'יל 500מג מטרוניד אזול",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960004124",
    "name": "אמפ פראמין 10 מ\"ג/2 מ\"ל",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960003322",
    "name": "אמפ. מים להזרקה 10 מ\"ל",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960003616",
    "name": "אמפולת סליין 10 סמ\"ק",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תיק ארן"
    ]
  },
  {
    "makat": "960040210",
    "name": "אפי-פן",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "962142575",
    "name": "אקדח BIG מבוגר",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "960190270",
    "name": "אקטיק (סוכריית מורפין)",
    "sources": [
      "ווסט מטב חדש",
      "חובש"
    ]
  },
  {
    "makat": "962043526",
    "name": "בוג'י",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962101194",
    "name": "בלון חמצן אלומיניום גדול ריק",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962101224",
    "name": "בלון חמצן קטן ריק תחתית כדורית",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "962101216",
    "name": "בלון חמצן קטן ריק תחתית שטוחה",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "962179029",
    "name": "ברז 3 כוונים פלסטי",
    "sources": [
      "קינפלואו",
      "תאים"
    ]
  },
  {
    "makat": "962053017",
    "name": "ג'ל רפואי; לא.ק.ג. ודפיברילטור",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "960305469",
    "name": "גזה דחוסה (Z-Fold)",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "960301188",
    "name": "גזת וזלין",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962673155",
    "name": "גלוקומטר פריסטייל",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "960006275",
    "name": "דורמיקום",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "962040594",
    "name": "דפיברילטור; חצי אוטומטי, פיליפס",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "960191714",
    "name": "דפירון, טבליות, 500 מ\"ג, אופטלגין",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960301447",
    "name": "הנדפלסט ביחידות 2*8 ס\"מ",
    "sources": [
      "ארגז חופל",
      "חופל",
      "תאים"
    ]
  },
  {
    "makat": "960006437",
    "name": "הקסאקפרון",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "965019049",
    "name": "ווסת חמצן עם העשרה וחיבור מהיר",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "962156193",
    "name": "ווסת, דרישה, חמצן; מכלל, מ. דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "965019022",
    "name": "וסת לחץ חמצן חיבור מהיר והעשרה",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "962216161",
    "name": "חוסם ורידים לשמוש שוטף",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962216030",
    "name": "חוסם ורידים סיליקון",
    "sources": [
      "חובש"
    ]
  },
  {
    "makat": "962216285",
    "name": "חוסם עורקים CAT",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "962053483",
    "name": "חיישן קפנו (CO2)",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "965120424",
    "name": "חיישן, ניטור חמצן, אצבע, ל.פ-12",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962100716",
    "name": "חמצן רפואי מילוי בבלון קטן",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "960110587",
    "name": "טבל מציצה לחטוי הגרון",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960191242",
    "name": "טבל פרויטבס",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960192567",
    "name": "טבליות לטיפול בצרבת",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960192168",
    "name": "טבליות סילאין ג'ל",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "441101163",
    "name": "טופס 101",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "960301064",
    "name": "טייפ פוליאטילן דביק 1X 9.14M",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960193407",
    "name": "טינקט כלורקסדין 100 סמק",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960060326",
    "name": "טיפות אף נפטוזלין 10 מ\"ל",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "96180569",
    "name": "טיפות עיניים לוקלין",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962129692",
    "name": "ידית לרינגוסקופ",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "962054870",
    "name": "כבל א.ק.ג. ; 3-ליד, מוניטור אטנה",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "962157041",
    "name": "כבל זרקור לרכב רק\"מ למנשם טקטי דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962053947",
    "name": "כבל חשמלי; דפיברילציה, ק.ח, LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962053920",
    "name": "כבל חשמלי; מוניטור ראשי, LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962040063",
    "name": "כבל כח 220V",
    "sources": [
      "אטנה",
      "קינפלואו",
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962053998",
    "name": "כבל מאריך לפאלס אצבע מדגם מסימו ל lp-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962156797",
    "name": "כבל שקע מצת לרכב מנשם טקטי דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962053904",
    "name": "כבל, אקג; 12 ליד, דפיברולט', LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962053912",
    "name": "כף דפיברילטור, חיצוני; LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962103456",
    "name": "כפפות ניטריל ח\"פ לא סטר-בינוני",
    "sources": [
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "962103464",
    "name": "כפפות ניטריל L",
    "sources": [
      "ווסט מטב חדש",
      "תאים"
    ]
  },
  {
    "makat": "962129056",
    "name": "להב מק מס' 3",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "962129064",
    "name": "להב מק מס' 4",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "960003314",
    "name": "לידוקאין 2%",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962156789",
    "name": "מארז צר\"פ; קשיח, מנשם טקטי, דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962145523",
    "name": "מארז, ציוד רפואי; QINFLOW, קשיח",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962054862",
    "name": "מארז, צר\"פ; גמיש, למוניטור אטנה",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "962156169",
    "name": "מארז, צר\"פ; גמיש, מנשם טקטי, דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962214118",
    "name": "מד חום דיגיטלי",
    "sources": [
      "ארגז חופל",
      "חובש",
      "חופל",
      "תיק ארן"
    ]
  },
  {
    "makat": "962214100",
    "name": "מד חום כספית",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "962214185",
    "name": "מד חום קליני היפוטרמי דיגיטלי",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962214363",
    "name": "מד חום, רפואי; עם חיישן פה",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962012183",
    "name": "מד לחץ דם אוטומטי",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962012019",
    "name": "מד לחץ דם עם שעון",
    "sources": [
      "ארגז חופל",
      "חופל",
      "תאים"
    ]
  },
  {
    "makat": "962011195",
    "name": "מד סטורציה",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "965022643",
    "name": "מד רווית חמצן נונין-סנסור אצבע",
    "sources": [
      "אטנה",
      "נונין"
    ]
  },
  {
    "makat": "962011152",
    "name": "מד רווית חמצן; אצבע, דגם MD300",
    "sources": [
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "962053475",
    "name": "מוניטור דפיברילטור; LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962054722",
    "name": "מוניטור; זעיר, ATNA-500",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "960003470",
    "name": "מורפין",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962187838",
    "name": "מזרק 10 סמ\"ק",
    "sources": [
      "ווסט מטב חדש",
      "תאים",
      "תיק ארן"
    ]
  },
  {
    "makat": "962187765",
    "name": "מזרק 3 סמ\"ק",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "962142001",
    "name": "מחט לואד 21 גייג' 1.5\"",
    "sources": [
      "ארגז חופל",
      "ווסט מטב חדש",
      "חובש",
      "חופל",
      "תאים",
      "תיק ארן"
    ]
  },
  {
    "makat": "962145507",
    "name": "מחסנית, ח\"פ; מכ' חימום ערוי, Q.F",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962145647",
    "name": "מחסנית; מכ חימום נוזל, זעיר, Q.F",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962054765",
    "name": "מטען לסוללה; מוניטור, ATHENA",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "962145515",
    "name": "מטען סוללה; מכשיר חימום לערוי",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962054838",
    "name": "מטען סוללה; קפנומטר אטנה",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "962155537",
    "name": "מיקרו מנשם-פילטר חיצוני",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962156657",
    "name": "מכ הנש,מלא,אמבו,מסכה שקופה,מ.5",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962145477",
    "name": "מכ חימום נוזלים, עירוי QIN-FLOW",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962156070",
    "name": "מכ' הנשמה ידני אמבו סיליקון Mark 4",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962043500",
    "name": "מכוון אנדוטרכיאלי,ח\"פ,סטרילי",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960030176",
    "name": "מכשיר דוחה יתושים",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962070515",
    "name": "מלקחיים מגיל לאנטובציה א-נ-380",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962156126",
    "name": "מנשם; טקטי, נייד, \"דרור\", סט מלא",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962041787",
    "name": "מסיכה ח\"פ למתן חמצן עם שקית",
    "sources": [
      "דף 5",
      "תאים"
    ]
  },
  {
    "makat": "962156142",
    "name": "מסנן למנשם; מלבני, טקטי, דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962154085",
    "name": "מסנן; מנשם ויראלי/בקטריאלי, HME",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962162410",
    "name": "מספריים לחומר ע\"כ 16 20 ס\"מ",
    "sources": [
      "ארגז חופל",
      "ווסט מטב חדש",
      "חובש",
      "חופל",
      "תיק ארן"
    ]
  },
  {
    "makat": "962217060",
    "name": "מע לערוי נוזלים",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962000940",
    "name": "מעביר אוויר פלסטי מס' 1",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962101550",
    "name": "מפתח ברגים, פתוח; 32 מ\"מ בלוני גז",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "965004742",
    "name": "מקור כוח, סוללה ; קפנומטר",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "962003044",
    "name": "מקלות עץ 6 אינץ עם צמר-גפן",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962153909",
    "name": "משאבה מופעלת רגל יוניפמפ",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960300505",
    "name": "משולשי בד",
    "sources": [
      "ווסט מטב חדש",
      "חובש"
    ]
  },
  {
    "makat": "960150139",
    "name": "משחה וזלין לבן 10 גרם",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962123406",
    "name": "משחה לקטטריזציה",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "960201051",
    "name": "משחה פוזידרם קומפוזיטום",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "962145485",
    "name": "מתאם מטען סוללה; מכ' חימום ערוי",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962054803",
    "name": "מתאם, נתיב אוויר, CO2; קפנו EMMA",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "962053890",
    "name": "מתאם, ספק כח; עם כבל חשמלי, LP15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962017720",
    "name": "נורה רזרבית ללרינגוסקופ רגיל",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962052770",
    "name": "נייר, רישום, מכשור רפואי; LP-12",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962125565",
    "name": "ניצב עם להב 115 סטרילי ח\"פ",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "965002200",
    "name": "נרתיק לאוטוסקופ/לרינגוסקופ",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962180019",
    "name": "סאקשן ידני (ויטולוגרף)",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962173926",
    "name": "סד רגל; תומס CT-6",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "960302141",
    "name": "סדין למיטה; למיטת אמבולנס",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "965004173",
    "name": "סוללה נטענת למנשם רפאל",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "965120440",
    "name": "סוללה; ליתיום דפי LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "965900136",
    "name": "סוללה; מכשיר עירוי QIF",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962115837",
    "name": "סט לאינהלציה; למבוגר, חד פעמי",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962177913",
    "name": "סטטוסקופ למרפאה",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "962178200",
    "name": "סטטוסקופ פשוט",
    "sources": [
      "ארגז חופל",
      "ווסט מטב חדש",
      "חופל",
      "תיק ארן"
    ]
  },
  {
    "makat": "962054501",
    "name": "סנסור אוזן למד רוו חמצן-נונין",
    "sources": [
      "נונין"
    ]
  },
  {
    "makat": "962211259",
    "name": "ספר/דיסק הפעלה למכשור רפואי",
    "sources": [
      "אטנה",
      "קינפלואו",
      "מוניטור LP-15",
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "967040096",
    "name": "ער צר\"פ לפרוצדורה תפירה כללית",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "967040010",
    "name": "ערכת אינטובציה",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "967040053",
    "name": "ערכת נקז חזה",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "967040100",
    "name": "ערכת פתיחת וריד",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תיק ארן"
    ]
  },
  {
    "makat": "962180060",
    "name": "ערכת קוניוטומיה",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "967040045",
    "name": "ערכת קוניוטומיה",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "960302109",
    "name": "פדי גזה 3*3\" סטריליים",
    "sources": [
      "ארגז חופל",
      "חובש",
      "חופל",
      "תאים"
    ]
  },
  {
    "makat": "960301889",
    "name": "פדים סטריליים לחיטוי עור",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "960180488",
    "name": "פולידין נוזלי 20 מ\"ל",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960050363",
    "name": "פונגיסיד אבקה 30 גרם",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962081002",
    "name": "פינצטה",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "966300019",
    "name": "פנס אצבע",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962128556",
    "name": "פנס מצח",
    "sources": [
      "ווסט מטב חדש",
      "חובש"
    ]
  },
  {
    "makat": "960190050",
    "name": "פראצטמול, טבליות, 500 מ\"ג",
    "sources": [
      "ארגז חופל",
      "חובש",
      "חופל"
    ]
  },
  {
    "makat": "962222072",
    "name": "צינור הארכה לעירוי 1.5 מ' דק",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962154263",
    "name": "צינור חמצן עם חיבור מהיר- מנשם",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962156134",
    "name": "צינור למנשם; טקטי, לחולה, דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962156185",
    "name": "צינור למנשם; ס. העשרה, ל. נמוך, דרור",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "960300092",
    "name": "צמר גפן 100 גרם בשקית",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962222099",
    "name": "צנור הארכה לערוי סטרילי 50 ס\"מ",
    "sources": [
      "קינפלואו"
    ]
  },
  {
    "makat": "962222293",
    "name": "צנור פלס 2 מ' 6 מ\"מ לווסת חמצן",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "962053831",
    "name": "צנור; למנג'טת לחץ דם, דפיבר-LP15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "960005260",
    "name": "צפטריאקסון;1 גרם,אמפ.לוריד",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962022170",
    "name": "קטטר אינפוזיה בטיחותי 14 ג'י",
    "sources": [
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "962022146",
    "name": "קטטר אינפוזיה בטיחותי 18 ג'י",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962022200",
    "name": "קטטר אינפוזיה בטיחותי 20 ג'י",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962021433",
    "name": "קטטר טרכיאלי; 5.5 מ\"מ,עם בלון",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962021450",
    "name": "קטטר טרכיאלי; 6.5 מ\"מ,עם בלון",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962021468",
    "name": "קטטר טרכיאלי; 7.5 מ\"מ,עם בלון",
    "sources": [
      "תיק ארן"
    ]
  },
  {
    "makat": "962021859",
    "name": "קטטר סאקשן 16",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "967040026",
    "name": "קטטר פולי (לעצירת דימום)",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "960003235",
    "name": "קטמין",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "960003233",
    "name": "קטמין 50",
    "sources": [
      "ווסט מטב חדש",
      "תיק ארן"
    ]
  },
  {
    "makat": "960300955",
    "name": "קיבוע, חזה-סנטר-צוואר; לובו",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "962054510",
    "name": "קפנומ-גלאי דו תחמוצת הפחמן בדם",
    "sources": [
      "נונין"
    ]
  },
  {
    "makat": "962054528",
    "name": "קפנומ-מתאם פלסטי לגלאי CO2",
    "sources": [
      "נונין"
    ]
  },
  {
    "makat": "962054544",
    "name": "קפנומטר נונין 9487 חדש",
    "sources": [
      "נונין"
    ]
  },
  {
    "makat": "962054080",
    "name": "קפנומטר עם מד רווית חמצן",
    "sources": [
      "נונין"
    ]
  },
  {
    "makat": "962054536",
    "name": "קפנומטר-נרתיק נשיאה",
    "sources": [
      "נונין"
    ]
  },
  {
    "makat": "962054811",
    "name": "קפנומטר; למוניטור אטנה",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "960020626",
    "name": "קפס אימודיום לופרמיד 2 מ\"ג",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960194055",
    "name": "קרם ביפונאזול 1%, 15 גרם",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "960200330",
    "name": "קרם זובירקס 2 גרם",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "960200314",
    "name": "קרם נגד פטריות",
    "sources": [
      "ארגז חופל",
      "חופל"
    ]
  },
  {
    "makat": "962053971",
    "name": "רצועת כתף; תיק נשיאה לדפיב, LP15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "960302753",
    "name": "שמיכת הצלה",
    "sources": [
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "960302052",
    "name": "שמיכת חימום אקטיבית",
    "sources": [
      "ווסט מטב חדש",
      "תאים"
    ]
  },
  {
    "makat": "960140257",
    "name": "שמן פרפין 100 מ\"ל",
    "sources": [
      "ארגז חופל"
    ]
  },
  {
    "makat": "962156150",
    "name": "שנאי; מנשם טקטי דרור, AC/DC",
    "sources": [
      "מנשם טקטי דרור"
    ]
  },
  {
    "makat": "962156100",
    "name": "שקית העשרה בחמצן למנשם אמבו",
    "sources": [
      "דף 5",
      "תיק ארן"
    ]
  },
  {
    "makat": "960002989",
    "name": "שקית הרטמן 500",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תיק ארן"
    ]
  },
  {
    "makat": "962053858",
    "name": "שרוול לחץ, מד ל.ד; מנג'טה, ג, LP15",
    "sources": [
      "מוניטור LP-15"
    ]
  },
  {
    "makat": "962054854",
    "name": "שרוול, מ.ל.ד. ; מבוגר, מוניט אטנה",
    "sources": [
      "אטנה"
    ]
  },
  {
    "makat": "960300777",
    "name": "תחבושת אישית אלסטית",
    "sources": [
      "חובש",
      "תאים",
      "תיק ארן"
    ]
  },
  {
    "makat": "960300779",
    "name": "תחבושת אישית תוצרת בריטניה",
    "sources": [
      "חופל"
    ]
  },
  {
    "makat": "960301242",
    "name": "תחבושת אלסטית; לבטן",
    "sources": [
      "חובש",
      "תאים"
    ]
  },
  {
    "makat": "960300980",
    "name": "תחבושת גזה 3\"",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "חופל",
      "תיק ארן"
    ]
  },
  {
    "makat": "960300867",
    "name": "תחבושת מטלין",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תיק ארן"
    ]
  },
  {
    "makat": "960300866",
    "name": "תחבושת נגד כויות מטלין",
    "sources": [
      "תאים"
    ]
  },
  {
    "makat": "960302818",
    "name": "תחבושת עוצרת דימום",
    "sources": [
      "ווסט מטב חדש",
      "חובש",
      "תאים",
      "תיק ארן"
    ]
  },
  {
    "makat": "962180051",
    "name": "תיק אינטובציה",
    "sources": [
      "ווסט מטב חדש"
    ]
  },
  {
    "makat": "962162169",
    "name": "תיק להעשרה בחמצן, לאמבולנס",
    "sources": [
      "דף 5"
    ]
  },
  {
    "makat": "962053963",
    "name": "תיק, נשיאה; לדפיבולטור, LP-15",
    "sources": [
      "מוניטור LP-15"
    ]
  }
];

export default makatData;
